import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Marker from '../Marker';
import TestResultsScale from '../TestResultsScale';
import PrivacyIcon from '../../../../../../PrivacyIcon';
import { HistoryNavigation } from '../HistoryNavigation';
import { getSafeAbnormalStatus } from '../../../../utils';
import { SCALE_BACKGROUND_COLOR } from '../../../../../constants';
import { useLabTestResultDetailsData } from '../useLabTestResultDetailsData';
import { labResultHistoryModalActions } from '../../../../../../../redux/healthboard/patientPortal/lab-result-history-modal';

import styles from './index.styl';

const LabTestResultDetailsCard = ({
  entity = {},
  headerMode,
  formatMessage,
}) => {
  const { componentCode, componentAvailability } = entity;
  const {
    safeValue,
    isPrivate,
    componentName,
    safeViewValue,
    safeNormalRange,
    shouldShowScale,
    rangePointsArray,
    componentResultValue,
    componentAbnormalStatus,
  } = useLabTestResultDetailsData({ entity });

  const dispatch = useDispatch();

  const handleOpenHistory = () => {
    if (componentAvailability) {
      dispatch(
        labResultHistoryModalActions.open({
          componentCode,
          name: componentName,
        }),
      );
    }
  };

  if (headerMode) {
    return (
      <div className={styles.rootHeader}>
        <div className={styles.nameResult} />
        <div className={styles.headerTitle}>
          {formatMessage({ id: 'patient.portal.labTestResult.result' })}
        </div>
        <div className={styles.headerTitle}>
          {formatMessage({
            id: 'patient.portal.labTestResult.normalRangeState',
          })}
        </div>
        <div className={styles.arrowButton} />
      </div>
    );
  }

  return (
    <div
      onClick={handleOpenHistory}
      className={cn(styles.root, {
        [styles.rootHover]: componentAvailability,
      })}
    >
      <div className={styles.testName}>
        {componentName}
        {isPrivate && (
          <PrivacyIcon className={styles.privacyIco} show={isPrivate} />
        )}
      </div>
      <div className={styles.content}>
        {safeViewValue}
        <span className={styles.abnormalStatus}>
          {getSafeAbnormalStatus(componentAbnormalStatus)}
        </span>
      </div>
      {safeNormalRange ? (
        <div className={styles.content}>{safeNormalRange}</div>
      ) : (
        <div className={styles.content}>&#8212;</div>
      )}
      <div className={styles.historyButton}>
        <HistoryNavigation
          name={componentName}
          formatMessage={formatMessage}
          componentAvailability={componentAvailability}
        />
      </div>

      {shouldShowScale && (
        <TestResultsScale
          formatMessage={formatMessage}
          rangesPoints={rangePointsArray}
          height={16}
          backgroundColors={SCALE_BACKGROUND_COLOR}
          points={[
            {
              value: safeValue,
              marker: <Marker value={componentResultValue} />,
            },
          ]}
          edges={['', '']}
        />
      )}
    </div>
  );
};

LabTestResultDetailsCard.propTypes = {
  entity: PropTypes.object,
  headerMode: PropTypes.bool,
  formatMessage: PropTypes.func,
};

export default LabTestResultDetailsCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/LabTestResultDetailsCard/index.jsx